import { Progress, Stack, Text } from '@mantine/core'
import { useEffect, useState } from 'react'
import { useNotify, useTranslate } from 'react-admin'
import { ScamExportJobResponseApiDTO } from '../../../codegen/generated/Api.schemas'
import { useGetApiScamExportExportStatusJobId } from '../../../codegen/generated/scam-export'
import { FileHelper } from '../../../helpers/File.helper'

type SCAMExportsProgressProps = {
  jobId: ScamExportJobResponseApiDTO['id'] | undefined
  onSuccess: () => void
}

export const SCAMExportsProgress = ({ jobId, onSuccess }: SCAMExportsProgressProps) => {
  const notify = useNotify()
  const t = useTranslate()

  const [refetchInterval, setRefetchInterval] = useState(1000)

  const exportJobQuery = useGetApiScamExportExportStatusJobId(jobId ?? '', {
    query: { enabled: !!jobId, refetchInterval },
  })

  useEffect(() => {
    if (exportJobQuery.data?.body.job.progress === 100) {
      setRefetchInterval(0)

      if (exportJobQuery.data?.body.job.data.signedUrl) {
        FileHelper.downloadUrl(exportJobQuery.data?.body.job.data.signedUrl)

        notify(t('pages.exports.toast_exportSuccess'), {
          type: 'success',
        })
        onSuccess()
      }
    }
  }, [exportJobQuery.data?.body.job, onSuccess, t, notify])

  return (
    <Stack justify="center" w="100%" py="lg">
      <Progress
        value={(exportJobQuery.data?.body.job.progress as number) ?? 0}
        animated={exportJobQuery.data?.body.job.progress !== 100}
        color={
          exportJobQuery.isError
            ? 'red'
            : exportJobQuery.data?.body.job.progress === 100
              ? 'green'
              : undefined
        }
      />
      {exportJobQuery.isError ? (
        <Text size="sm" fs="italic" w="100%" ta="center" c="red">
          {exportJobQuery.error.message}
        </Text>
      ) : (
        <Text size="sm" fs="italic" w="100%" ta="center">
          {t('pages.exports.exportInProgress')}…
        </Text>
      )}
    </Stack>
  )
}
